module.exports = __webpack_public_path__ + "static/media/illustartion-creativity.1fecb007.svg";